import { ChatConnector } from "./chatConnectorBase";
import { NullChatConnector } from "./chatConnectorNull";

// Module level variable to hold the currently loaded and configured chat connector
const chatConnector: ChatConnector = new NullChatConnector();

export const getChatConnector = (): ChatConnector => {
    return chatConnector;
};
